module.exports = __webpack_public_path__ + "static/media/CT.dc6607cb.png";